import React from "react";
import { Button, Form } from 'react-bootstrap';
import {toastSaveSuccessful} from "../dialogs/ModalContext";
import {useAxiosSetup} from "../Api";
import ProgressBar from "../dialogs/ProgressBar";

function PricelistLoader(props) {
    const api = useAxiosSetup();

    const fileInputRef = React.useRef(null);
    const [savingInProgress, setSavingInProgress] = React.useState(false)

    const handleButtonClick = () => {
        // Programmatically trigger the click event on the hidden file input
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        setSavingInProgress(true)
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            api.post("/service_case/service_cases_spare_parts/upload_pricelist/", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).catch(() => {
                setSavingInProgress(false)
            }).then((response) => {
                    toastSaveSuccessful()
                setSavingInProgress(false)
            })
        }
    };

    return (
        <Form>
            <Button variant="primary" onClick={handleButtonClick}>
                Upload File
            </Button>
            {/* Hidden file input element */}
            <Form.Control
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
            {savingInProgress && <ProgressBar/>}
        </Form>
    );
}

export default PricelistLoader
